import { AddButton } from "@/shared/form/button";
import { FormInModal } from "@/shared/form/form-in-modal";
import { useTranslations } from "use-intl";
import { SaveDynamicProcessModel } from "./save-dynamic-process-model";
import { FC } from "react";

export type SaveDynamicProcessModelInModalProps = {
  processId?: string;
  Trigger?: FC<{
    onClick: () => void;
  }>;
};

export function SaveDynamicProcessModelInModal({
  processId,
  Trigger,
}: SaveDynamicProcessModelInModalProps) {
  const t = useTranslations("DynamicProcesses");

  return (
    <FormInModal
      modalProps={{
        width: 900,
      }}
      title={t("Full dynamic process")}
      trigger={(open) =>
        Trigger ? (
          <Trigger onClick={open} />
        ) : (
          <AddButton type="text" onClick={open}>
            {t("Full dynamic process")}
          </AddButton>
        )
      }
      form={(close) => (
        <SaveDynamicProcessModel afterSubmit={close} modelId={processId} />
      )}
    />
  );
}
